export default __webpack_public_path__ + "static/media/isf-dark.aabd0126.svg";